import { Component, OnInit,ElementRef, ViewChild,AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';

import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { MaeProcesoService } from 'src/app/service/mae-proceso.service';
import { DetArchivoService } from 'src/app/service/det-archivo.service';
import { GlobalVariablesService } from 'src/app/service/global-variables.service';
import { DetParticipanteService } from 'src/app/service/det-participante.service';

import { MovFirmaParticipanteM } from 'src/app/model/det-participante-bean';
import { Response_dml_bean } from 'src/app/model/response-dml';

@Component({
  selector: 'app-dml-firma',
  templateUrl: './dml-firma.component.html',
  styleUrls: ['./dml-firma.component.scss']
})
export class DmlFirmaComponent implements OnInit {
  constructor(
   // public sanitizer: DomSanitizer,
    private route: ActivatedRoute,
   // public  modalRefFirmaDml: MDBModalRef,
    private utilitarioService:UtilitarioService,
    private detArchivoService:DetArchivoService,
    private detParticipanteService:DetParticipanteService,
    private maeProcesoService:MaeProcesoService,
    private globalVariablesService: GlobalVariablesService,
  ){

  }
  //variables enviado desde el padre
  x_titulo:String;
  c_id:String;
  tipo_firma:string;
  a_tipo:String;
  x_tipo:String;
  c_constancia:String;
  c_participante:String;
  c_iduser:String;
  esunitario:boolean=true;

  MovFirmaE:MovFirmaParticipanteM;
  Response_Masivo:Response_dml_bean;

  tempBlob:Blob;
  pdfSource:string;
  pdfRutaApi:string;

  //datos para firma
  serverSubir:string;
  //image = 'https://apiserviciosrnb.bnp.gob.pe:8443/rnb/carpeta/logo_azul.png';
  image:string;
  //image = 'https://www.bnp.gob.pe/wp-content/uploads/2017/08/favicon_logo.fw_.png';

  // position= '[355, 800, 575, 840]';
  position= '[280,100,570,150]';
  fileName:string;
  filedata:string;
  bundle:string;
  valor_boton:string;

  ngOnInit(): void {

    this.c_iduser = this.globalVariablesService.getC_usuario();
    console.log('ini-pre->'+localStorage.getItem('iterador'));
    this.pageRefresh();//recuperar parametro

    this.serverSubir = this.detArchivoService.baseURLFirma;
    this.image = this.serverSubir + 'Content/logo_azul.png';
    this.route.params.subscribe((params: Params) => {
      //console.log(params);
      this.tipo_firma = params['tipo'];
      this.c_id =  params['id'];

      if(this.tipo_firma.length==1)
      { // es firma unitaria
        this.bundle = 'NO';
        this.valor_boton = 'Firmar Constancia';
        this.inicializarTipo('a');
        this.cargarDatoInicialUnitario();
      }
      else
      {
        this.esunitario=false
        //firma masiva
        this.c_constancia = this.c_id;
        this.c_id = '0';
        this.bundle = 'YES';
        this.valor_boton = 'Firmar todas las Constancias';
        this.inicializarTipo('ma');
        this.x_titulo = 'Firma Digital de todos los '+this.x_tipo+':';
        this.cargarDatoInicialMasivo();
      }
    });
  }
  inicializarTipo(tipo_alumno:string)
  {
    if(this.tipo_firma === tipo_alumno)
    {
      this.a_tipo='a';
      this.x_tipo = 'Alumnos';
      this.x_titulo = 'Firma Digital de Alumno:';
    }
    else
    {
      this.a_tipo='p';
      this.x_tipo = 'Profesores';
      this.x_titulo = 'Firma Digital de Profesor:';
    }
  }

  pageRefresh() {
    if(localStorage.getItem('iterador')=== '0'){
      localStorage.setItem('iterador', '1');
      location.reload();
    }
    console.log('ini-after->'+localStorage.getItem('iterador'));
  }

  cargarDatoInicialUnitario(){
    this.utilitarioService.loading = true;
    const cargaDatosFirma  = this.detParticipanteService.getsign(this.c_id.toString()).toPromise()
    .then(result => {
      console.log(result);
      this.MovFirmaE = result[0];
      this.c_constancia = this.MovFirmaE.c_constancia.toString();
      console.log(this.MovFirmaE);
    });
    Promise.all([cargaDatosFirma])
    .then(response => {

      const cargarArchivo = this.detArchivoService.getFilePdf(this.MovFirmaE.x_uid.toString(),this.c_constancia.toString()).toPromise()
        .then(blobData => {
        this.tempBlob = new Blob([blobData], { type: 'application/pdf' });
        this.pdfSource = window.URL.createObjectURL(this.tempBlob);
        this.fileName = 'documentofirma.pdf';
        this.pdfRutaApi = this.detArchivoService.getRutaArchivoFirma(this.c_constancia.toString(),'.pdf');
        this.utilitarioService.loading = false;
      });
    });
  }

  cargarDatoInicialMasivo(){
    this.utilitarioService.loading = true;

    this.maeProcesoService.juntarenZip(this.c_constancia.toString(),this.c_iduser.toString()).subscribe(
      response_dml_bean=>{
      console.log(response_dml_bean);
      this.Response_Masivo = response_dml_bean;
      if(this.Response_Masivo.codigoRespuestaServicio=='1')
      {
        this.fileName ='generadofirma.zip';
        this.pdfRutaApi = this.detArchivoService.getRutaArchivoFirma(this.c_constancia.toString(),'.zip');
        this.utilitarioService.loading = false;
        this.utilitarioService.toastrInfo(this.Response_Masivo.mensaje);
      }
      else
      {
        this.utilitarioService.loading = false;
        this.utilitarioService.toastrError(this.Response_Masivo.mensaje);
      }

    },error=>{
      this.utilitarioService.loading=false;
      this.utilitarioService.toastrError("Hubo un error al crear el archivo zip, intente nuevamente.");
      console.log(error.error.messages.toString());
    }/*,error=>{
      this.maeProcesoService.juntarenZip(this.c_constancia.toString(),this.c_iduser.toString()).subscribe(
        response_dml_bean=>{
        console.log(response_dml_bean);
        this.Response_Masivo = response_dml_bean;
        if(this.Response_Masivo.codigoRespuestaServicio=='1')
        {
          this.fileName ='generadofirma.zip';
          this.pdfRutaApi = this.detArchivoService.getRutaArchivoFirma(this.c_constancia.toString(),'.zip');
          this.utilitarioService.loading = false;
          this.utilitarioService.toastrInfo(this.Response_Masivo.mensaje);
        }
        else
        {
          this.utilitarioService.loading = false;
          this.utilitarioService.toastrError(this.Response_Masivo.mensaje);
        }

      },error=>{
        this.utilitarioService.loading=false;
        this.utilitarioService.toastrError("Hubo un error al crear el archivo zip, intente nuevamente.");
        console.log(error.error.messages.toString());
      });
    }*/);

  }

}
